import { baseRequestWithHeaders } from './base-request';

export const getCommentForARequest = requestId => {
  const url = `comments/${requestId}/new-requests`;
  const method = 'GET';
  return baseRequestWithHeaders(url, method);
};

export const addCommentForARequest = (requestId, comment, type) => {
  const url = `comments/${requestId}/requests?t=${type}`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, { comment, type });
};
